import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FenceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fence"}/>
}
